import { render, staticRenderFns } from "./DropdownPartnerItem.vue?vue&type=template&id=4952f659"
import script from "./DropdownPartnerItem.vue?vue&type=script&lang=js"
export * from "./DropdownPartnerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports